export default __webpack_public_path__ + "static/dwa-logo-476d80bdc6343c2ba68ef9476a50610e.svg";